import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PortalInfoResponse } from '../models/portal.model';

@Injectable({
  providedIn: 'root',
})
export class PortalService {
  private readonly url = '/api/student/entry-page-info';
  private readonly http: HttpClient = inject(HttpClient);

  getPageInfo(): Observable<PortalInfoResponse> {
    return this.http.get<PortalInfoResponse>(this.url);
  }
}
